class SlideSequence {
  constructor(uploadResponse) {
    this._fileId = uploadResponse.fileId;
    this._slides = uploadResponse.slides;
    // Add promo tweet to end.
    this.addCreditsTweet();
    this.setSlideTextAsEditText();
  }

  get slides() {
    return this._slides;
  }

  get totalSlides() {
    return this.slides.length;
  }

  setSlideTextAsEditText() {
    this.setEditText('slideText');
  }

  setNotesTextAsEditText() {
    this.setEditText('notesText');
  }

  setBlankTextAsEditText() {
    this.slides.forEach((slide) => {
      if (!slide.isLocked) {
        slide.editText = '';
      }
    });
  }

  setEditText(slideProp) {
    this.slides.forEach((slide) => {
      if (!slide.isLocked) {
        slide.editText = slide[slideProp] || '';
      }
    });
  }

  addCreditsTweet() {
    this._slides.push({
      slideNum: this._slides.length,
      editText: `Created using @TweetMySlides - Share your PowerPoint slides as a Twitter thread.`,
      isLocked: true
    });
  }

  removeCreditsTweet() {
    this._slides.pop();
  }

}

export default SlideSequence;


// WEBPACK FOOTER //
// ./src/models/slide-sequence.js